import {useState, useEffect} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import * as CoreFns from '../utilities/CoreFns';
import * as FormulaFunctions from '../utilities/FormulaFunctions';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';
import SelectorBar from '../StockItems/SelectorBar';
import NormalBtn from '../StockItems/NormalBtn';
import ActualCredits from './ActualCredits';

function App(props) {

  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var width = props.width;
  var nosCredits = props.nosCredits;
  var setNosCredits = props.setNosCredits;
  var requirements = props.requirements;
  var chains = props.chains;

  const [packageSelected, setPackageSelected] = useState({});
  const [creditHistory, setCreditHistory] = useState(false);
  const [whichPage, setWhichPage] = useState(0);
  const [typedReferringKey, setTypedReferringKey] = useState('');

  const [chainIdSelected, setChainIdSelected] = useState(0);
  
  function getCredits(){
    var postFunction = function(responseIn){
      setNosCredits(responseIn.v);
    }
    if (signKey){
      var passObject = {
          u:"getCredits",
          sessionID,
          userID,
          signKey,
        };
      ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
      
    }
  }

  function onMessage(event){
    var data = event.data;
    if (data.show === 'dbhchat'){
      if (data.message === 'close'){
        setPackageSelected({});
        getCredits();
      }
    }
  }
  useEffect(() => {

    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);  
    };
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    getCreditHistory();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps



  var failFunction = function(){
    console.log("Fail");
  }

  function getCreditHistory(){

    function postClientSecret(response){
      setCreditHistory(response);
    }
    var passObject = {
        u:'getCreditHistory',
        sessionID,
        signKey,
        userID,
      };
    ServerComms.fetchSomething(passObject, postClientSecret, failFunction, []);
  }

    var checkoutPage;
    if (whichPage === 0){


      function clickPackageRow(anOption, paymentType){

        return function(e){
          setPackageSelected({anOption, paymentType});
        }
      }
   
      var optionsCredits = [{i:0, t:5,p:10}, {i:1, t:10,p:20}, {i:2, t:30,p:56}, {i:3, t:50,p:90}, {i:4, t:100,p:160}, {i:5, t:200,p:310}];
      var creditRows = optionsCredits.map((anOption, index)=>{
        var txt = 'USD ' + anOption.p + '.00';
        var txt1 =  anOption.p + ' Stable Coins';
        var bottomText = <NormalBtn onClick={clickPackageRow(anOption, 'cash')} title={txt}/>
        var cryptoText = <NormalBtn onClick={clickPackageRow(anOption, 'crypto')} title={txt1}/>
        return <tr key={index} ><td>+ {anOption.t} credits</td><td>{bottomText}</td><td>{cryptoText}</td></tr>
  //
      })


      if (packageSelected && packageSelected.paymentType === 'cash'){

        var packageSelectedX = packageSelected.anOption;
        checkoutPage = <div className="col-lg-10 mx-auto text-center">
                          <iframe title='Add Credits' src={'https://www.cues.sg/credits?se='+sessionID+'&sk='+signKey+'&u='+userID+'&p='+packageSelectedX.p+'&t='+packageSelectedX.t+'&i='+packageSelectedX.i} style={{width:'100%', height:width, border:'0px solid black'}}></iframe>
                        </div>
      }else if (packageSelected && packageSelected.paymentType === 'crypto'){

        function clickBackHere(e){
          setPackageSelected({});
        }

        var set;
        if (chainIdSelected === 0){

          function sChain(chainId){
            return function(e){
              setChainIdSelected(chainId);
            }
          }
          var chains1 = [{ci:56, n:'Binance'}, {ci:137, n:'Polygon'}];
          if (userID === 512){
            chains1.push({ci:80001, n:'Temp Mumbai'});
            chains1.push({ci:97, n:'Temp BSC'});
          }
          var chainRows = chains1.map((aChain, index)=>{
            return <tr key={index}><td>{aChain.n}</td><td><NormalBtn onClick={sChain(aChain.ci)} title='Select'/></td></tr>
          })
          set = <div>
              <TableWrapRowsBoot rows={chainRows} headerCells={['Chain', '']}/>
              <p className='lead mb-0'>Please contact us on Telegram @cuessg if you would like to pay using other coins.<br/><br/></p>
              <NormalBtn onClick={clickBackHere} title='Back'/>
              </div>
//
        }else{

            set = <ActualCredits userID={userID} sessionID={sessionID} signKey={signKey} chains={chains} getCredits={getCredits} chainIdSelected={chainIdSelected} setChainIdSelected={setChainIdSelected} packageSelected={packageSelected} />


            
        }


        checkoutPage = <div className="col-lg-10 mx-auto text-center">
              <p className='lead mb-0'>Purchase {packageSelected.anOption.t} credits using {packageSelected.anOption.p} coins.</p><br/>
              {set}
          </div>
//
      }else{


        var referringKeyLine;
        if (creditHistory){
          var refSet1 = creditHistory.v[2].v;
          if (refSet1[0].v && refSet1[0].v[0]){
            var referringUserID = refSet1[0].v[1].v;
            var referringUserKey = refSet1[0].v[2].v;

            if (referringUserID){
              referringKeyLine = <p className='lead mb-0'>You were referred by : {referringUserKey}</p>
    //          
            }else{

              function onChange(e){
                setTypedReferringKey(e.target.value);
              }
              function onInputKeyDown(e){
                if (e.keyCode === 13){
                  if (typedReferringKey){
                    function postClientSecret(response){
                      if (response.t === 'atom'){
                        window.alert('Sorry, referral key ' + typedReferringKey + ' does not exist.');
                      }else{
                        setCreditHistory(response);
                      }
                    }
                    var passObject = {
                        u:'addReferralKey',
                        sessionID,
                        signKey,
                        userID,
                        typedReferringKey,
                      };
                    ServerComms.fetchSomething(passObject, postClientSecret, failFunction, []);
                  }else{
                    window.alert('Referral Key cannot be blank');
                  }
                }
              }  

              referringKeyLine = <div><p className='lead mb-0'>If you were referred to Cues.sg by a friend, you can add their referral key so that they will earn credits whenever you add credits.</p><input autoFocus className='inputBoxClass' value={typedReferringKey} onChange={onChange} onKeyDown={onInputKeyDown} style={{width:'30%'}} placeholder='Referral Key' /></div>
            }

          }
        }

        checkoutPage = <div className="col-lg-10 mx-auto text-center">
          {referringKeyLine}
          <TableWrapRowsBoot rows={creditRows}/>
          </div>
      }
//

    }else if (whichPage === 1){

      if (creditHistory){
        if (creditHistory.v[0].v.length + creditHistory.v[4].v.length === 0 ){
          checkoutPage = <div className="col-lg-10 mx-auto text-center">
          <br/>
           <p className="lead mb-0">No previous top-ups</p>
         </div>

        }else{
            var topUpRows = creditHistory.v[0].v.map((aRow, index)=>{
                var dateVal = FormulaFunctions.getDateFromSql(aRow.v[0]);

                return <tr key={index}><td>{dateVal}</td><td>{aRow.v[1].v}</td><td>{aRow.v[2].v}</td></tr>
              })
            
            var tradFi;
            if (topUpRows.length > 0){
              tradFi = <TableWrapRowsBoot rows={topUpRows} headerCells={['Date', 'Cost (USD)', 'Credits Added']}/>
            }
            var deFi;
            var deFiRows = creditHistory.v[4].v.map((aRow, index)=>{
                var dateVal = FormulaFunctions.getDateFromSql(aRow.v[0]);
                var relevantChainName = CoreFns.getRelevantChain(aRow.v[1].v, chains).n1;

                return <tr key={index}>
                    <td>{dateVal}</td>
                    <td>{relevantChainName}</td>
                    <td>{aRow.v[2].v}</td>
                    <td>{aRow.v[3].v}</td>
                    <td>{aRow.v[4].v + ' ' + aRow.v[5].v + ' ' + aRow.v[6].v}</td>
                    <td>{aRow.v[7].v}</td>
                </tr>

            })
//
            if (deFiRows.length > 0){
              deFi = <TableWrapRowsBoot rows={deFiRows} headerCells={['Date', 'Chain', 'Transaction', 'From', 'Coin', 'Credits Added']}/>
            }

              checkoutPage = <div className="col-lg-10 mx-auto text-center">
                          {tradFi}
                          {deFi}
                        </div>
//
        }

      }
//
    }else if (whichPage === 2){

      if (creditHistory){
        if (creditHistory.v[1].v.length === 0){
          checkoutPage = <div className="col-lg-10 mx-auto text-center">
          <br/>
           <p className="lead mb-0">No previous purchases</p>
         </div>

        }else{
          var expenditureRows = creditHistory.v[1].v.map((aRow, index)=>{
            var dateVal = FormulaFunctions.getDateFromSql(aRow.v[0]);
            var purchaseCode = aRow.v[2].v;
            var txt;
            if (purchaseCode === 1){
              txt = 'Generate Contract Code'
            }else if (purchaseCode === 2){
              txt = 'Generate dApp Code';
            }else if (purchaseCode === 3){
              txt = 'Added ' + aRow.v[3].v + ' days to dApp';
            }else if (purchaseCode === 5){
              txt = 'Uploaded image/audio file to IPFS';
            }
            return <tr><td>{dateVal}</td><td>{aRow.v[1].v}</td><td>{txt}</td></tr>
          })

          checkoutPage = <div className="col-lg-10 mx-auto text-center">
                    <TableWrapRowsBoot rows={expenditureRows} headerCells={['Date', 'Number of Credits', 'Item Purchased']}/>
                    </div>
          
  //

        }
      }
//
    }else if (whichPage === 3){

      var referralKeyLine;
      var previousReferrals;
      if (creditHistory){
        var refSet = creditHistory.v[2].v;
        if (refSet[0].v && refSet[0].v[0]){
          var ownReferralKey = refSet[0].v[0].v;

          if (ownReferralKey){
            referralKeyLine = 'Get your friends to quote your referral key ' + ownReferralKey + ' . Every 10 credits that they add will yield you 2 credits.';
          }else{
            referralKeyLine = 'Once you add credits, you will be given a referral key so that you can earn credits whenever your friends add credits.';
          }

        }


        if (creditHistory.v[3].v.length === 0){
          previousReferrals = <p className="lead mb-0">No previous referrals</p>
//
        }else{
          var referralRows = creditHistory.v[1].v.map((aRow, index)=>{
            var dateVal = FormulaFunctions.getDateFromSql(aRow.v[0]);
            return <tr><td>{dateVal}</td><td>{aRow.v[1].v}</td></tr>
          })
          previousReferrals = <TableWrapRowsBoot rows={referralRows} headerCells={['Date', 'Number of Credits Received']}/>
  //
        }
      

      }
      checkoutPage = <div className="col-lg-10 mx-auto text-center">
         <p className="lead mb-0">{referralKeyLine}</p>
         <br/>
         {previousReferrals}
      </div>
    }
//

    var opt = [{t:'Add Credits', i:0}, {t:'Top Ups', i:1}, {t:'Purchases', i:2}, {t:'Referrals', i:3}];

    function clickWhichPage(x){
      setWhichPage(x)
      setPackageSelected({});
    
    }

    var requirementsLine;
    if (requirements){
      var p = requirements - nosCredits;
      if (p > 0){
        requirementsLine = <p className="lead mb-0">Credits Shortfall: {p}</p>
      }
    }

    return <div className="container" style={{width}}>
        <div className="row mb-4">
          <div className="col-lg-10 mx-auto text-center">
           <p className="lead mb-0">Number of Credits : {nosCredits}</p>
           <p className="lead mb-0">Credits expire after 1 year</p>
           {requirementsLine}
         </div>
         </div>
          <SelectorBar options={opt} currentAnswer={whichPage} setSelections={clickWhichPage}/>
        <div className="row mb-4">
        {checkoutPage}
        </div>
      </div>

  //


}

export default App;
